export default __webpack_public_path__ + "static/media/slide8.50404f77.jpg";